import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({

    en: {
        title: "The progress report",
        content: "Accountability is a core part of our EDI journey. We will assess our progress and measure success against established objectives and activities. We will also publish status updates on how we’re doing.",
        button: 'View the latest report',
        alt:"Photo of Gary the Unicorn high fiving Ian Hanomansing",
        legend:"Gary the Unicorn gives a high-five to Ian Hanomansing",
        link: "https://cbc.radio-canada.ca/en/impact-and-accountability/diversity-and-inclusion/initiatives/update-june2021"
    },
    fr: {
        title: "Compte rendu de nos progrès",
        content: "La responsabilisation est partie prenante de notre évolution dans le dossier EDI. Les progrès feront l’objet d’une évaluation, et les résultats obtenus seront comparés aux objectifs fixés et aux activités prévues. Par ailleurs, nous publierons des mises à jour sur l’avancée de nos démarches.",
        button: 'Consulter les rapports les plus récents',
        alt:"Photo de Gary la licorne faisant un high-five à Ian Hanomansing.",
        legend:"Gary the Unicorn tape dans la main de Ian Hanomansing",
        link:"https://cbc.radio-canada.ca/fr/transparence-et-engagement/diversite-et-inclusion/initiatives/mise-a-jour-juin-2021"
       
    }
});

export default strings;